import { ApiProperty } from "@nestjs/swagger";
import { JobWorkStatus } from "../entity/price-negotiation-entity";

export class VendorStatusUpdateReq {
    @ApiProperty()
    id: number;

    @ApiProperty({ enum: JobWorkStatus })
    jobWorkStatus: JobWorkStatus;

    @ApiProperty()
    vendorId: number;
}
